import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import { get } from 'lodash'
import { Title, Overview, CircleBadge } from 'components/misc'
import { getActivityIconName, getActivityClassName } from 'helpers/dashboard'
import { ACTIVITY_SECTIONS } from 'constants/enums'

const actOverviewMock = { loading: false }
const rpColorClass = getActivityClassName(
  ACTIVITY_SECTIONS.residential_project.id
)
const titleStyle = { float: 'left', marginRight: 10 }

class RPOverview extends Component {
  static propTypes = {
    rp: PropTypes.object.isRequired,
    downloadButton: PropTypes.any
  }

  render() {
    const { rp, downloadButton } = this.props

    return (
      <div>
        <Title colorClass={rpColorClass} h3 bold>
          <CircleBadge colorClass={rpColorClass} style={titleStyle} small>
            {getActivityIconName(ACTIVITY_SECTIONS.residential_project.id)}
          </CircleBadge>
          <FormattedMessage
            id="moduleTitle.residential_project"
            defaultMessage="Residential Project"
          />
        </Title>

        <div className="row">
          <div className="col-xs-12 col-md-6">
            <Overview
              activityOverview={actOverviewMock}
              activitySection={ACTIVITY_SECTIONS.residential_project.id}
              content={[
                {
                  id: '88',
                  content: get(rp, 'state.translationText'),
                  intlKey: 'label.status',
                  label: 'Status',
                  ico: 'info'
                },
                {
                  id: '89',
                  content: get(rp, 'startDate'),
                  intlKey: 'label.start_date',
                  label: 'Start Date',
                  ico: 'date',
                  date: true
                },
                {
                  id: '90',
                  content:
                    get(rp, 'assessorName') &&
                    `${get(rp, 'assessorTitle')} ${rp.assessorName}`,
                  intlKey: 'label.name',
                  label: 'Name',
                  ico: 'face'
                }
              ]}
            />
          </div>
          <div className="col-xs-12 col-md-6">
            <Overview
              activityOverview={actOverviewMock}
              activitySection={ACTIVITY_SECTIONS.residential_project.id}
              content={[
                {
                  id: '98',
                  content: get(rp, 'goal'),
                  intlKey: 'label.goal',
                  label: 'Goal',
                  ico: 'flag'
                },
                {
                  id: '99',
                  content: get(rp, 'endDate'),
                  intlKey: 'label.end_date',
                  label: 'End Date',
                  ico: 'date',
                  date: true
                }
              ]}
            />
          </div>
        </div>

        {downloadButton}
      </div>
    )
  }
}

export default RPOverview
